import { RequestUnsuccessComponent } from '../request-unsuccess/request-unsuccess.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { LeavePageModalComponent } from '../leave-page-modal/leave-page-modal.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { CustomTooltipComponent } from '../../custom-tooltip/custom-tooltip.component';
import { BillingHeaderComponent } from '../../billing-header/billing-header.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreLoadingComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-loading/mapfre-loading.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Constants } from '@models/constants';
import { ActivatedRoute, Params, Router , RouterModule } from '@angular/router';
import { switchMap, tap } from 'rxjs/operators';
import { FormBaseControlService, ModalOptions } from '@mapfre-design-library/src/public_api';
import { PolicyDataService } from '../../../../../../_services/data-services/policy-data.service';
import { BillingDetailsService } from '../../../../../../_services/my-insurance/billing-details.service';
import { SelfRequestFormService } from '../../../../../../_services/forms/self-request-form/self-request-form.service';
import{ NavigationService } from '../../../../../../_services/navigation.service';
import { StorageServiceObservablesService } from '../../../../../../_services/storage-service-observables/storage-service-observables.service';
import { UploadRequestDocumentsComponent } from '../upload-request-documents/upload-request-documents.component';
import { Topic } from '@models/topic';
import { DocumentService } from '@services/document/document.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbFormsModule, MapfreLoadingComponent, MapfreCardComponent, BillingHeaderComponent, CustomTooltipComponent, UploadRequestDocumentsComponent, MapfreButtonComponent, LeavePageModalComponent, MapfreModalComponent, RequestUnsuccessComponent],
  selector: 'app-cancellation-request',
  templateUrl: './cancellation-request.component.html',
  styleUrls: ['./cancellation-request.component.scss'],
  providers: [FormBaseControlService],
})
export class CancellationRequestComponent implements OnInit {
  @ViewChild(UploadRequestDocumentsComponent)
  uploadedDocs!: UploadRequestDocumentsComponent 

  documents: File[];
  failureSubmitModal: ModalOptions;
  loading: boolean;
  submitLoading: boolean;
  policy: any;
  policyType: string;
  policyTypeImg: string;
  requestType: string;
  inputs: any[];
  topicOptions: Topic[];
  requestFormGroup: FormGroup;
  cancelRequestInfo: string;
  showLeaveModal: boolean;
  showSubmitUnsuccessModal: boolean;
  hideModal = false;
  cancellationReason ='';
  isTooltipVisible = false;
  tooltipTitle='What is a Massachusetts Auto Transfer of Insurance 2A Form?';
  tooltipDescription='A 2A form is used to remove a car from your auto insurance policy. To cancel your policy, you must either cancel the plates or send us a 2A form showing the vehicle is now insured with a different insurance company. The form is always labeled as "Notice of Transfer of Insured" and will have a new carrier stamp on it.'
  constructor(
    private activatedRoute: ActivatedRoute,
    private policyDataService: PolicyDataService,
    private selfRequestForm: SelfRequestFormService,
    private docService: DocumentService,
    private storageObservable: StorageServiceObservablesService,
    private billingDetailsService: BillingDetailsService,
    private router: Router,
    private navigationService: NavigationService,
  ) { 

    this.submitLoading = false;
    this.showLeaveModal = false;
    this.showSubmitUnsuccessModal = false;
  }
  clearForm() {
    this.requestFormGroup = new FormGroup({
      cancellation_topic: new FormControl(null, Validators.required),
      addInfo: new FormControl('', Validators.required)
    });
  }

  ngOnInit(): void {
    this.loading = true;
    this.documents = [];
    this.requestType = "Cancellations";
    this.topicOptions = this.selfRequestForm.getCancellationsRequestTopicLists();
    this.activatedRoute.params.subscribe((params: Params) => {
      const policyId = params['policyid'];
      this.policyDataService.$policyDetails.subscribe((policyResponse) => {
        if (policyResponse) {
          this.policy = policyResponse
                          .find(policyDetails => policyDetails.policynumber.policyNumber === policyId);
          this.setPolicyTypeData(this.policy.policyType)
          this.loading = false;
        }       
      });
    });
    this.clearForm();
    this.initFailureSubmitModal();
  }

  setPolicyTypeData(policyType){
    this.policyType = this.policy?.policyType;
    if(policyType.includes('AUTO')){
      this.policyTypeImg = "./assets/img/images/icon-car-billing-question.svg";
    } else if (policyType.includes('HOME')){
      this.policyTypeImg = "./assets/img/images/icon-home-billing-question.svg";
      this.cancelRequestInfo = 'CANCEL_REQUEST_PROPERTY';
    }else{
      this.policyTypeImg = "./assets/img/images/icon-umbrella-billing-question.svg";
      this.cancelRequestInfo = 'CANCEL_REQUEST_UMBRELLA';
    }
  }

  initFailureSubmitModal(): void {
    this.failureSubmitModal = new ModalOptions({
      additionalClasses:
        'modal-lg modal-dialog center-on-page confirm-modal email-update edit-contact-modal',
      animatePosition: 'top',
      onLoad: true,
      modalId: 'failureSubmitModal',
      iconClasses: 'far fa-user-circle',
      iconFamily: 'font-awesome',
      size: 'modal-lg',
      modalName: 'failure-Submit-Modal',
    });
    this.loading = false;
  }

  resetHideModal(){
    this.hideModal = !this.hideModal;
  }

  sendRequest(){
    const subTopic = this.requestFormGroup.controls.cancellation_topic.value;   
    const insured = this.policy.insured.find(insured => insured.isPrimaryInsured);

    const emailContent = {
      policyNumber: this.policy.policynumber.policyNumber,
      policyType: this.policy?.displayType?.label?.toUpperCase() ?? this.policy?.policyType,
      firstName: insured.firstName,
      lastName: insured.lastName,
      inquiryDate: new Date().toLocaleDateString(),
      inquiryTime: new Date().toLocaleTimeString(),
      inquiryTopic: Constants.CANCELLATION_TOPIC,
      inquiry: this.requestFormGroup.controls.addInfo.value,
      email: this.storageObservable.getUserFromStorage(),
      addProperties: {inquirySubTopic: subTopic},
      isSelfCustomerRequest: true,
      hasAttachments: true
    };

    const requestPayload: FormData = new FormData();
    requestPayload.append('content', JSON.stringify(emailContent));
    this.documents.forEach((file) => {
      requestPayload.append('attachments', file, file.name);
    });
  
    this.submitRequest(requestPayload);    
  }

  submitRequest(payload: any){
    this.showSubmitUnsuccessModal = false;
    this.uploadedDocs.setLeavePage(true);
    this.submitLoading = true;
    this.docService.uploadSendGridAttachments(payload).pipe(
      tap(resp => {
        console.log("Cancellation Request :: Upload Docs done, status is ", resp)
      }),
      switchMap((uploadStatus: any) => {
        if(uploadStatus && 'COMPLETE' === uploadStatus)
          return this.billingDetailsService.sendBillingQuestion(payload.get("content"), this.storageObservable.getUserFromStorage())
      }))
      .subscribe(
        () => {
          this.router.navigate(['/my-insurance', this.policy.policynumber.policyNumber, 'self-request', 'success'], {
            queryParams: { request: 'cancellations' },
          });
          this.submitLoading = false;
        },
        () => {
          this.showSubmitUnsuccessModal = true;
          this.submitLoading = false;
          return;
        }
      );
  }

  saveUploadedFile(docs) {
    this.documents = docs;
  }

  onClickBack(){
    if(!this.requestFormGroup.controls.cancellation_topic.valid){
      this.router.navigate(['/my-insurance', this.policy.policynumber.policyNumber, 'other-request'], {
        state: { openModal: true, openOtherRequestModal:true },
      });
    }else{
      if(this.documents.length){
        this.showLeaveModal = true;
      }else{
        this.ngOnInit()
      }
    }
  }

  reload(event: boolean){
    this.showLeaveModal = false;
    if(event){
      this.ngOnInit()
    }
  }

  onReasonChange() {
    if(this.cancellationReason && this.cancellationReason !==  this.requestFormGroup.controls.cancellation_topic.value){
      this.uploadedDocs.leavePage(event);
      this.documents = [];
      this.requestFormGroup.controls.addInfo.setValue(null);
    }
    this.cancellationReason = this.requestFormGroup.controls.cancellation_topic.value;
  }

  tryAgain(event: boolean){
    this.showSubmitUnsuccessModal = false;
    if(!event){
      this.router.navigate(['/my-insurance', this.policy?.policynumber?.policyNumber, 'billing']);
    }
  }

  onClickClose(){
    this.navigationService.goBackToRecentUrl(['/contact', '/billing', '/home']);
  }

  onTolltipHover() {
    this.isTooltipVisible = true;
  }

  showToolTip(event) {
    this.isTooltipVisible = event;
  }
}